import { render } from "./SvgImage.vue?vue&type=template&id=33544bf3"
import script from "./SvgImage.vue?vue&type=script&lang=js"
export * from "./SvgImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__